import { GetterTree } from 'vuex';
import { State } from '@/store/modules/mobile/mobileCommonState/mobileCommon.store';

const getters: GetterTree<State, State> = {
  getAllMobileServices: state => {
    return state.mobileServices;
  },
  getMobileAppVersions: state => {
    return state.mobileAppVersions;
  },
  getMobileOSs: state => {
    return state.mobileOSs;
  },
  getCurrentMobileService: state => {
    if (state.currentMobileService.key === 'all')
      return { key: [], label: 'All' };
    return state.currentMobileService;
  },
  getCurrentMobileOS: state => {
    if (state.currentMobileOS.key === 'all')
      return { key: ['IOS', 'ANDROID'], label: 'All' };
    return { key: [state.currentMobileOS.key], label: state.currentMobileOS.label };
  },
  getCurrentMobileAppVersion: state => {
    if (state.currentMobileAppVersion.key === 'all')
      return { key: [], label: 'All' };
    return state.currentMobileAppVersion;
  },
  getAllIOSAppVersions: state => {
    return state.allIOSAppVersions;
  },
  getAllAndroidAppVersions: state => {
    return state.allAndroidAppVersions;
  },
};
export default getters;
